import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type FeesToolbarProps = {
  onAddRule: () => void;
  canCreate?: boolean;
};

export function FeesToolbar({ onAddRule, canCreate = true }: FeesToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ຈັດການຄ່າທຳນຽມແຜງ</h2>
        <p className="text-muted-foreground text-sm">
          ຈັດການຄ່າທຳນຽມ ແລະ ຄ່າຄອມມິດຊັນ
        </p>
      </div>
      {canCreate && (
        <Button onClick={onAddRule}>
          <PlusIcon className="size-4" />
          ເພີ່ມກົດໃໝ່
        </Button>
      )}
    </div>
  );
}
